module.exports = "/assets/702b19e0e2993dfe6edcc4aee8e21081.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/OS.png
// module id = 1691
// module chunks = 0